// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Aktiv',
    active_switch_description: 'Wenn Sie die Eigenschaft \'Aktiv\' eines Benutzers deaktivieren, wird eine Lizenz frei und der inaktive Benutzer wird (mit Ausnahme der Seite \'Benutzer\') nicht mehr im System sichtbar sein.',
    apply: 'Anwenden',
    assign: 'Hinzufügen',
    assigned_activities_menu_title: 'Zugewiesene Aktivitäten',
    can_login: 'Kann sich anmelden',
    can_login_switch_description: 'Wenn Sie \'Kann sich anmelden\' deaktivieren, entziehen Sie dem Benutzer nur den Zugriff zum System. Der Benutzer kann weiterhin Projektmitglied oder Beauftragter sein. Durch diese Aktion wird ebenfalls eine Lizenz frei.',
    cancel: 'Abbrechen',
    CanDenyLogin_User_DenyLoginYourself: 'Sie können die Option \'Kann sich anmelden\' nicht für sich selbst deaktivieren.',
    CanDenyLogin_User_LastAdministrator: 'Sie können die Option \'Kann sich anmelden\' nicht für den einzigen Administrator im System deaktivieren.',
    CanDisable_User_DisableYourself: 'Sie können die Option \'Aktiv\' nicht für sich selbst deaktivieren.',
    CanDisable_User_LastAdministrator: 'Sie können die Option \'Aktiv\' nicht für den einzigen Administrator im System deaktivieren.',
    cant_delete_user: 'Der Benutzer konnte nicht gelöscht werden',
    cant_login: 'Kann sich nicht anmelden',
    change_password: 'Passwort ändern',
    close: 'Schließen',
    convert_title: 'Konvertieren',
    convert_to_regular: 'Zu Standardbenutzer konvertieren',
    convert_to_regular_title: '{0} zu einem Standardbenutzer mit der folgenden Rolle konvertieren:',
    deactivate: 'Status ändern',
    deactivateTitle: 'Benutzerstatus auf Inaktiv setzen',
    delete: 'Löschen',
    delete_confirm: 'Diesen Benutzer löschen?',
    delete_skill_title: 'Fähigkeit löschen',
    delete_team_title: 'Team löschen',
    DeleteRateBtnTitle: 'Endgültig löschen',
    Disable_Permission_Message: 'Sie sind dabei, eine Berechtigung in Ihrer Rolle zu deaktivieren, die Ihnen die Bearbeitung Ihrer eigenen Berechtigungen und der Berechtigungen anderer Benutzer erlaubt.',
    Disable_Permission_Title: 'Sie können die Berechtigungen anderer Benutzer dann nicht mehr bearbeiten.',
    DisplayName_customerId: 'Kunde',
    DisplayName_email: 'E-Mail',
    DisplayName_hourlyRate: 'Standardstundensatz',
    DisplayName_hourlyRateInternal: 'Interner Stundensatz',
    DisplayName_login: 'Login',
    email: 'E-Mail',
    exclude: 'Ausschließen',
    filterbystatus_Active: 'Nur \'Aktiv\'',
    filterbystatus_All: '\'Aktiv\' und \'Inaktiv\'',
    filterbystatus_CannotLogin: 'Nur \'Kann sich nicht anmelden\'',
    filterbystatus_Inactive: 'Nur \'Inaktiv\'',
    generate: 'Generieren',
    guest_portal_title: 'Gäste-Portal interagieren.',
    guests_interaction: 'Gäste können mit dem System nur über das',
    guests_license: 'Sie benötigen keine Lizenz.',
    guests_users_tab_title: 'Gäste',
    import_title: 'Import',
    inactive: 'Inaktiv',
    lastActivityDate_title: 'Letzter Besuch',
    licensing_limits_warning: 'Sie können diesem Benutzer nicht die Anmeldung erlauben, da Ihre Lizenz keine weiteren Benutzer mit Anmelderecht zulässt.',
    name_column_title: 'Name',
    no_sercurity_logs: 'Dieser Benutzer hat noch keine Einträge',
    password_changed: 'Das Passwort wurde geändert.',
    personal_schedule_title: 'Persönlicher Zeitplan',
    regular_users_tab_title: 'Standard',
    reload: 'Aktualisieren',
    reset: 'Zuweisen',
    reset_password_confirmation: 'Bei einem Klick auf \"Generieren\" wird ein neues Passwort erstellt und per E-Mail an den Benutzer gesendet.',
    reset_password_done: 'Ein neues Passwort wurde erstellt und versendet.',
    reset_password_menu_title: 'Passwort generieren und per E-Mail versenden',
    reset_password_title: 'Möchten Sie das Passwort wirklich generieren und per E-Mail versenden?',
    reset_permissions_confirmation: 'Um die aktuelle Rolle des Benutzers ({0}) für alle Projekte zu übernehmen, in denen der Benutzer Mitglied ist, klicken Sie auf \'Zuweisen\'. Der Vorgang kann nicht rückgängig gemacht werden. Klicken Sie auf \'Abbrechen\', um abzubrechen.',
    reset_permissions_done: 'Die aktuelle Rolle wurde zugewiesen.',
    reset_permissions_menu: 'Aktuelle Rolle zuweisen',
    reset_permissions_title: 'Möchten Sie die aktuelle Rolle wirklich allen Projekten des Benutzers zuweisen?',
    security_logs_action: 'Aktion',
    security_logs_date: 'Datum',
    security_logs_modal_title: 'Sicherheitsprotokoll für',
    security_logs_title: 'Sicherheitsprotokoll',
    securitylog_msg_GuestConverted: 'Rolle geändert von Gast zu {0} von {1}.',
    securitylog_msg_LoginChanged: 'Anmeldename wurde von Benutzer {0} geändert.',
    securitylog_msg_LoginChangedBySelf: 'Anmeldename wurde geändert.',
    securitylog_msg_PasswordChanged: 'Passwort wurde von Benutzer {0} geändert.',
    securitylog_msg_PasswordChangedByRecovery: 'Passwort wurde wiederhergestellt.',
    securitylog_msg_PasswordChangedBySelf: 'Passwort wurde geändert.',
    securitylog_msg_PasswordGenerated: 'Passwort wurde von Benutzer {0} generiert.',
    securitylog_msg_PasswordGeneratedBySelf: 'Passwort wurde generiert.',
    securitylog_msg_PasswordIncorrect: 'Falsches Passwort.',
    securitylog_msg_RecoveryRequest: 'Wiederherstellungsanfrage.',
    securitylog_msg_RoleChanged: 'Rolle geändert von {0} zu {1} von {2}.',
    securitylog_msg_UserLockout: 'Benutzer wurde nach ungültigen Passwortversuchen gesperrt.',
    securitylog_msg_UserLockoutDueToInactivity: 'Benutzer wurde aufgrund von Inaktivität geblockt.',
    securitylog_msg_UserUnlocked: 'Benutzer wurde von Benutzer {0} entsperrt.',
    selected_users: '1#{0} Benutzer ausgewählt#{0} Benutzer ausgewählt',
    Set_teams: 'Teams',
    show: 'Anzeigen',
    show_other_reasons: 'Andere Gründe anzeigen',
    skills: 'Fähigkeiten',
    skills_updated_successfully: 'Die Fähigkeiten wurden erfolgreich aktualisiert',
    skillsDeleteConfirm: 'Die Fähigkeit wird aus den Fähigkeiten aller Benutzer entfernt',
    suggest_deactivate: 'Sie können den Benutzer überall in {brandName} ausblenden (mit Ausnahme der Seite \'Benutzer\' und des Verlaufs der Projekt- und Aufgabenzuweisung) und seinen Status auf \'Inaktiv\' setzen. Auf diese Weise können Sie eine Lizenz für einen anderen Benutzer freigeben.',
    teams: 'Teams',
    teams_updated_successfully: 'Die Teams wurden erfolgreich aktualisiert',
    teamsDeleteConfirm: 'Das Team wird aus den Teams aller Benutzer entfernt',
    TimerText: '1#{0} Sekunde#{0} Sekunden',
    unlock: 'Entsperren',
    user_conversion_done: '{0} wurde erfolgreich konvertiert.',
    user_conversion_title: 'Benutzerkonvertierung',
    user_duplicate_email_error: 'Ein Benutzer mit der angegebenen E-Mail-Adresse ist schon vorhanden',
    user_duplicate_login_error: 'Ein Benutzer mit diesem Anmeldenamen ist schon vorhanden',
    user_licensing_limits_warning: 'Sie können die Anmeldeerlaubnis für diesen Benutzer nicht aktivieren, da die Lizenz keine weiteren Arbeitsplätze erlaubt.',
    User_NotFound_Title: 'Gesuchter Benutzer wurde nicht gefunden',
    userRates: 'Ratenverlauf',
    userRates_date: 'Änderungsdatum',
    userRates_hourlyRate: 'Abrechnungsrate',
    userRates_hourlyRateInternal: 'Interne Rate',
    userRates_title: 'Ratenverlauf für {0}',
};
